import { InferType, number, object } from 'yup';
import { Nullable } from '../../../model/common';
import { currencyIdSchema, safeString } from './common';

interface PortalCryptoWithdrawalSchemaParams {}

export const portalCryptoWithdrawalSchema = (params: PortalCryptoWithdrawalSchemaParams) => {
    return object({
        currencyId: currencyIdSchema('Withdrawal Currency cannot be empty!'),
        walletId: object({ label: safeString(), value: number() }).required('Please select a wallet.'),
        // amount value must be greater than 0
        amount: safeString().min(0, 'Amount must be more than 0').required('Amount cannot be empty!'),
        requestDescription: safeString()
    });
};

export type PortalCryptoWithdrawalFormValues = InferType<ReturnType<typeof portalCryptoWithdrawalSchema>>;
export type PortalCryptoWithdrawalFormInput = Nullable<PortalCryptoWithdrawalFormValues>;
